import React, { Fragment } from 'react';
import PageHeader from "../components/PageHeader";
import PageAbout from "../components/About/page";
import Services from "../components/Services";
import PricingTable from "../components/PricingTable";
import Testimonial from "../components/Testimonials/home-two";
import BrandLogo from "../components/BrandLogo";
import Funfact from "../components/Funfact";
import CallToAction from "../components/CallToAction";
import Footer from "../components/Footer";
import LoginRegister from "../components/LoginRegister";
import MobileMenu from "../components/MobileMenu";
import Ofersindex from '../components/ofers/index';
import ServiceThumb from '../assets/img/homecare-services2.jpg'
import Blog from "../components/Blog";
import HeaderTwo from '../components/Header/indextwo';
import FooterTwo from '../components/Footer/indextwo';
import CallToActionTwo from '../components/CallToAction/indextwo';
import MobileMenuTwo from '../components/MobileMenu/indextwo';
import ServicesTwo from '../components/Services/indextwo';

const ServiceTwo = () => {
    return (
        <Fragment>
            <HeaderTwo/>
            <PageHeader
                bgImg={require('../assets/img/homecare-services.jpg')}
                title="OUR SERVICES"
                content="We help companies that do good look good."
            />
            <ServicesTwo classes="sm-top-wt" />
            <Funfact ribbonColor="#BB2649" />
            <CallToActionTwo />
            <FooterTwo />
            <LoginRegister />
            <MobileMenuTwo />
        </Fragment>
    );
};

export default ServiceTwo;